"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="hidden md:flex gap-1">
        <div className="h-9 w-20 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map(item => <NavigationMenuItem key={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="group inline-flex h-9 w-max items-center justify-center px-4 py-2 text-sm font-medium text-foreground-dark transition-all hover:!bg-transparent focus:!bg-transparent hover:text-primary focus:text-foreground-dark relative after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-300 hover:after:w-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden hover:!bg-transparent focus:!bg-transparent text-foreground" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-dark-background border-t border-border-light md:hidden shadow-medium">
          <nav className="flex flex-col p-4 gap-2">
            {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="px-4 py-3 text-sm font-medium text-foreground-dark hover:text-primary transition-all hover:!bg-transparent focus:!bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 rounded-md" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '' || path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-dark-background border-b border-border-light/20 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isScrolled ? 'py-2 shadow-medium' : 'py-4 shadow-soft'}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between gap-8">
          {}
          <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/ekonorm_logo.png" alt="Ekonorm" className="h-7" />
          </Link>

          {}
          <MenuProvider menu_id="3" className="flex-1 flex justify-center">
            <HeaderMenuConsumer />
          </MenuProvider>

          {}
          <Button asChild className="hidden md:inline-flex hover:!bg-primary-hover active:!bg-primary-active focus:!bg-primary hover:scale-105 active:scale-100 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
            <Link to="#">Keuring Aanvragen</Link>
          </Button>
        </div>
      </div>
    </header>;
}